import { jsx as _jsx } from "react/jsx-runtime";
import { Alert, Box, Skeleton } from '@mui/material';
import { AccumulatorTable } from '../common/AccumulatorTable';
const debug = process.env.REACT_APP_DEBUG && false;
export const ObjectDataAccumulationCard = ({ accumulator, error, mode }) => {
    if (error)
        return _jsx(Alert, { severity: "error", children: error });
    if (accumulator === undefined)
        return _jsx(Skeleton, { variant: "rounded", width: "100cqw", height: "3em" });
    return (_jsx(Box, { width: "100cqw", maxHeight: "80cqh", overflow: "scroll", children: _jsx(AccumulatorTable, { accumulator, mode }) }));
};
